import { logFeature } from '@office-start/telemetry-service';
var AppHostPageService = /** @class */ (function () {
    function AppHostPageService(navigateForwardCallback, navigateToAppCallback, setShareLinkCallback, setFrameInfoCallback, addEventListenerCallback, services) {
        var _this = this;
        var _a, _b;
        this.navigateForwardCallback = navigateForwardCallback;
        this.navigateToAppCallback = navigateToAppCallback;
        this.setShareLinkCallback = setShareLinkCallback;
        this.setFrameInfoCallback = setFrameInfoCallback;
        this.addEventListenerCallback = addEventListenerCallback;
        this.returnFocus = function (navigateForward) {
            var _a;
            if (navigateForward) {
                return Promise.resolve(_this.navigateForwardCallback());
            }
            else {
                logFeature({
                    featureName: "MOSHub" /* KnownFeatureNames.MOSHub */,
                    eventName: 'ReturnFocus',
                    params: {
                        AppCapabilities: 'FocusOnAppBar',
                        DebugInfo: "focus set to app tile in App Bar",
                        Service: 'ReturnFocusPageService',
                    },
                    area: 'MOSAppHost',
                    subArea: 'AppHostPageService',
                });
                return Promise.resolve((_a = _this.appbarConnectorService) === null || _a === void 0 ? void 0 : _a.focusOnAppbar());
            }
        };
        this.setCurrentFrame = function (frameInfo) {
            return Promise.resolve(_this.setFrameInfoCallback(frameInfo));
        };
        this.navigateToApp = function (params) {
            return Promise.resolve(_this.navigateToAppCallback(params));
        };
        this.shareDeepLink = function (params) {
            _this.setShareLinkCallback(params);
            return Promise.resolve();
        };
        this.clearListeners = function () {
            /** TODO */
        };
        this.appLinkDomains = (_a = services === null || services === void 0 ? void 0 : services.appLinkDomains) !== null && _a !== void 0 ? _a : [];
        this.appbarConnectorService = services === null || services === void 0 ? void 0 : services.appbarConnectorService;
        this.appButtonService =
            (_b = this.appbarConnectorService) === null || _b === void 0 ? void 0 : _b.getAppButtonService();
        this.tabsService = services === null || services === void 0 ? void 0 : services.tabsService;
        this.configService = services === null || services === void 0 ? void 0 : services.configService;
        this.backStackService = services === null || services === void 0 ? void 0 : services.backStackService;
        this.fullTrustService = services === null || services === void 0 ? void 0 : services.fullTrustService;
    }
    AppHostPageService.prototype.addEventListener = function (type, listener) {
        if (this.addEventListenerCallback) {
            this.addEventListenerCallback(type, listener);
        }
    };
    return AppHostPageService;
}());
export { AppHostPageService };
//# sourceMappingURL=AppHostPageService.js.map